/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { defaultToastConfig } from '@/configs/toast'
import { listMultipleAssetsUrls } from '@/configs/urls'
import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useToast
} from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const RetryModal = ({
  batchId,
  batchName,
  getAccessToken,
  onClose,
  onRetry,
  retryBatch,
  assetData
}) => {
  const toast = useToast()
  const navigate = useNavigate()
  const modalItem = retryBatch
    ? 'asset listing batch for building SAMs'
    : 'asset listing for building SAMs'
  const title = `Retry ${modalItem}`
  const handleContinue = () => {
    const retryParams = { batchId }
    toast({
      title: `Retry ${modalItem}`,
      description: `The ${modalItem} is being processed; we will notify you when it is finished.`,
      status: 'info',
      ...defaultToastConfig
    })

    !retryBatch && (retryParams.itemId = assetData.id)
    onRetry && onRetry(retryParams, getAccessToken)

    navigate(`/${listMultipleAssetsUrls.base}`)
  }

  const textBody = retryBatch
    ? `The asset listing batch: "${batchName}" will be retried. We will notify you whe it's done.`
    : `The process of creating the asset listing:  "${assetData?.title}"  will be retried. We will notify you whe it's done.`

  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{ title }</ModalHeader>
        <ModalCloseButton onClick={onClose} />
        <ModalBody>
          <div className="mb-4">
            { textBody }
          </div>
          <ButtonGroup gap='4'>
            <Button
              colorScheme="gray"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button onClick={handleContinue}>
              Continue
            </Button>
          </ButtonGroup>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default RetryModal
